import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { UserAuthData } from 'src/app/core/auth/authData.model';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
@Component({
  selector: 'vex-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  styleUrls: ['./toolbar-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatRippleModule, MatIconModule]
})
export class ToolbarUserComponent implements OnInit {
  dropdownOpen: boolean = false;
  currentUser: UserAuthData | null = null;
  fullName: string = '';
  imagen: string | ArrayBuffer | null = null;


  constructor(
    private popover: VexPopoverService,
    private cd: ChangeDetectorRef,
    private authService: AuthService
  ) {}

ngOnInit() {
  this.currentUser = this.authService.getCurrentUser();

  // Obtener y modificar fullName para mostrar solo primer nombre y apellido
  this.fullName = this.limitarNombreCompleto(this.authService.getCurrentUserFullName());

  // Corregido: Eliminada la suscripción duplicada
  this.authService.currentUser$.subscribe(user => {
    this.currentUser = user;
    if (user) {
      this.fullName = this.limitarNombreCompleto(this.authService.getCurrentUserFullName());
      if (user.imagen) {
        this.imagen = user.imagen;
      }
      this.cd.markForCheck();
    }
  });
}

// Método para limitar el nombre completo al primer nombre y apellido
private limitarNombreCompleto(nombreCompleto: string): string {
  if (!nombreCompleto) return '';

  // Dividir el nombre completo en palabras
  const palabras = nombreCompleto.trim().split(/\s+/);

  // Si solo hay una o dos palabras, devolver todo el nombre
  if (palabras.length <= 2) {
    return nombreCompleto;
  }

  // Para nombres más largos, tomar el primer nombre y el primer apellido
  // Asumiendo que los apellidos comienzan en la mitad de las palabras (aproximadamente)
  const posicionPrimerApellido = Math.floor(palabras.length / 2);

  return `${palabras[0]} ${palabras[posicionPrimerApellido]}`;
}
  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
